import { useState } from 'react'
import QueryBuilder from './querying/queryBuilder.js'
import ResultsPanel from './dataOutput/resultsPanel.js';
import BlupsResultsPanel from './blups/blupsResultsPanel.js';
import { getFilteredOptions } from '../utilities/filteringLogic.js';
import { getData } from '../services/api.js';
import { notification } from 'antd';
import ClipLoader from "react-spinners/ClipLoader";
/** For delayed service -- may be used in the future 
import Notification from '../delayedservicecomp/notification';
*/

function DataQueryComponent({ dataType, filterObject, filters, requiredFilters, selectedDBCode, title }) {
    const [notificationApi, contextHolder] = notification.useNotification({ maxCount: 1 });
    const [data, setData] = useState({ data: [] });
    const [queryRunning, setQueryRunning] = useState(false);

    const runQuery = async (selectedOptions) => {
        setQueryRunning(true);
        if (requiredFilters.every(filter => selectedOptions[filter].length > 0)) {
            const response = await getData(selectedDBCode, dataType, selectedOptions)
            //console.log('Response in Data Query ',response)
            //console.log('Response in Data query comp ',response)
            if (!response.error) {
                
                if (dataType === 'blups') {
                    setData({
                        data: response.data,
                        traits: response.traits,
                        years: response.years,
                        countByYear: response.countByYear,
                        countByLocYear: response.countByLocYear,
                        traitAverage: response.traitAverage
                    });
                }
                else {
                    setData({
                        data: response.data
                    });
                }
            }
            else {
                setData({ data: [] });
                notificationApi.error({
                    message: 'Query Failed',
                    description: response.message,
                    duration: 0,
                    placement: 'top',
                })
            }
        }
        else {
            notificationApi.error({
                message: 'Query Failed',
                description: 'Check that you have selected at least one option for all required filters (marked with *)',
                duration: 0,
                placement: 'top',
            })
        }
        setQueryRunning(false);
    }

    return (
        <>
            {contextHolder}
            <div className="container-sm query-page-container">

                <QueryBuilder
                    title={title}
                    filters={filters}
                    getFilteredOptions={(tab, selectedOptions) => {
                        return getFilteredOptions(dataType, filterObject, tab, selectedOptions)
                    }}
                    runQuery={runQuery}
                    requiredFilters={requiredFilters}
                />

                {queryRunning ?
                    <div className="d-flex justify-content-center my-5">
                        <ClipLoader
                            color={"#38724f"}
                            loading={true}
                            size={100}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />
                    </div>
                    :
                    data.data.length > 0 ?
                        dataType === 'blups' ?
                            <BlupsResultsPanel
                                data={data}
                            />
                            :
                            <ResultsPanel
                                data={data.data}
                                dataType={dataType}
                            />
                        :
                        <></>
                }
            </div>
        </>
    );

}

export default DataQueryComponent;